import "./TabList.scss";
import TabListDesktop from "./TabListDesktop";
import TabListMobile from "./TabListMobile";

interface TabButtonProps {
  text?: string;
  propertyName?: string;
  selected?: boolean;
  onClick: () => void;
}

export interface Props {
  mobileHeading?: string;
  tabButtons: TabButtonProps[];
}

const TabList = ({ tabButtons, mobileHeading }: Props) => (
  <div className="tab-list-norad">
    <TabListDesktop tabButtons={tabButtons} />
    <TabListMobile tabButtons={tabButtons} heading={mobileHeading} />
  </div>
);

export default TabList;
